var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.report && Object.keys(_vm.report['customers-frequency'] || {}).length)?_c('div',{staticClass:"report"},[_vm._v("\n\tHello World!\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }